/* TNC AOV boosters: one-tap cart adds, XL swap, product-page aftercare add-on */
(function () {
  if (window.__tncAov) return;
  window.__tncAov = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
      return r.json();
    });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ id: Date.now(), sections: sections }); });
  }

  // Asia & Global markets: convert the USD free-shipping threshold to the shopper's currency
  function fmt(cents, cur) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' ' + cur;
    }
  }

  function initBars() {
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var boxes = document.querySelectorAll('[data-tnc-fsbox]:not([data-tnc-done])');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      box.setAttribute('data-tnc-done', '1');
      var fs = Math.ceil(parseFloat(box.dataset.tncFsUsd) * rate) * 100;
      var total = parseInt(box.dataset.tncTotal, 10) || 0;
      var cur = box.dataset.tncCur;
      var label = box.querySelector('[data-tnc-label]');
      var meter = box.querySelector('[data-tnc-meter]');
      if (total >= fs) {
        label.textContent = 'Tattoo Bliss. You’ve unlocked free shipping.';
        meter.style.width = '100%';
        continue;
      }
      var gap = fs - total;
      label.textContent = 'You’re ' + fmt(gap, cur) + ' away from free shipping.';
      meter.style.width = Math.floor((total * 100) / fs) + '%';
      if (total <= 0) continue;
      var cands = box.querySelectorAll('[data-tnc-cand]');
      var pick = null, fallback = null;
      for (var j = 0; j < cands.length; j++) {
        var price = parseInt(cands[j].dataset.price, 10);
        if (price >= gap && (!pick || price < parseInt(pick.dataset.price, 10))) pick = cands[j];
        if (!fallback || price > parseInt(fallback.dataset.price, 10)) fallback = cands[j];
      }
      var chosen = pick || fallback;
      if (!chosen) continue;
      chosen.hidden = false;
      chosen.querySelector(pick ? '[data-tnc-full]' : '[data-tnc-part]').hidden = false;
    }
  }

  initBars();
  new MutationObserver(initBars).observe(document.documentElement, { childList: true, subtree: true });

  // One-tap add (and optional swap) buttons in the cart drawer
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tnc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var chain = Promise.resolve();
    if (btn.dataset.tncRemove) {
      chain = chain.then(function () { return post('cart/change.js', { id: btn.dataset.tncRemove, quantity: 0 }); });
    }
    chain
      .then(function () { return post('cart/add.js', { items: [{ id: Number(btn.dataset.tncAdd), quantity: 1 }] }); })
      .then(refreshDrawer)
      .catch(function (err) {
        console.error('TNC add failed', err);
        btn.removeAttribute('aria-busy');
      });
  });

  // Product page: if the aftercare box is ticked, add it first, then let the theme add the main product
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.id) return;
    var cb = document.querySelector('[data-tnc-addon][data-form="' + form.id + '"]');
    if (!cb || !cb.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cb.checked = false;
    post('cart/add.js', { items: [{ id: Number(cb.dataset.tncAddon), quantity: 1 }] })
      .catch(function (err) { console.error('TNC add-on failed', err); })
      .then(function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
  }, true);
})();
